import { create } from 'zustand'
import mixpanel from 'mixpanel-browser'
import { authFetch } from '../common/utils/cognito'
import { SupportedLanguages } from '../common/types/translatable'

type User = {
  appRating: number | null
  id: number
  language: SupportedLanguages
  onboarding: {
    complete: boolean
  }
  tracks: Array<{ id: number }>
  userSub: string
}

interface UserStore {
  currentUser?: User
  fetchUser: () => Promise<void>
}

export const useUserStore = create<UserStore>((set) => ({
  currentUser: undefined,
  fetchUser: async () => {
    const currentUser = await fetchUser()
    mixpanel.identify(currentUser.userSub)
    set({ currentUser })
  },
}))

const fetchUser = async () => {
  const response = await authFetch(`${process.env.REACT_APP_API_URL}/me`)

  if (response.ok) {
    return (await response.json()) as User
  } else {
    throw new Error(response.statusText)
  }
}
